export enum ErrorsEnum {
  INVALID_TOKEN = 'Given token not valid for any token type'
}
